export default __webpack_public_path__ + "static/media/Fitness.0f210a0c.webp";